<template>
    <div class="project">
        <div class="banner" ref="banner">
            <img :src="setImg('project-banner')" alt="">
        </div>
        <div class="project-nav" ref="projectNav" :class="fiexdNav" :style="{top: fiexdTop+'px'}">
            <ul class="w">
                <li v-for="(item,index) in navList" 
                    :class="activeStep==index?'active':''" 
                    @click="toLetters(index)"
                    :key="index">
                    {{ item }}
                </li>  
            </ul>
        </div>
        <div class="scroll-content">
            <div class="origin scroll-item" id="scroll-1">
                <Head-title class="animate__animated" title="工业互联网标识解析企业节点Origin系列" name="提供了工业互联网标识解析体系接入、工业互联网标识注册与管理、企业内部数据收集沉淀与价值挖掘、基于工业互联网标识解析的场景应用等功能"></Head-title>
                <div class="origin-tab" :class="applyClass">
                    <div class="origin-tit">
                        <ul class="w tab_tit">
                            <li v-for="(item,index) in originList" :key="index" :class="tab==index?'active':''" @click="changeTab(index)">
                                <span class="icon"></span>
                                <dl>
                                    <dt>{{ item.title }}</dt>
                                    <dd v-dompurify-html="item.des"></dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                    <div class="w tab-cont">
                        <ul class="origin-list">
                            <li v-for="(item,index) in tabList[tab]" :key="index">
                                {{ item }} 
                            </li>
                        </ul>
                    </div>
                </div> 
            </div>
            <div class="function" id="scroll-2">
                <Head-title class="animate__animated" title="产品功能" name="直面工业互联网标识解析复杂难点"></Head-title>
                <ul class="w function-cont">
                    <li v-for="(item,index) in functList" :key="index"> 
                        <span>{{ item.name }}</span>
                        <em v-dompurify-html="item.des"></em>
                    </li>
                </ul>
            </div>
            <div class="apply scroll-item" id="scroll-3">
                <Head-title class="animate__animated" title="应用场景" name="为企业在工业互联网持续赋能"></Head-title>
                <div class="w">
                    <img :src="setImg('apply-bg')" alt="">
                    <ul class="apply-list">
                        <li v-for="(item,index) in applyList" :key="index">
                            <b>{{ item.name }}</b>
                            <em>{{ item.des }}</em>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="data-link scroll-item" id="scroll-4">
                <Head-title class="animate__animated" title="数据连接器" name="ORIGIN的好伙伴、企业内部数据的吸尘器"></Head-title>
                <div class="w">
                    <ul>
                        <li v-for="(item,index) in dataList" :key="index">
                            {{ item }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="feature scroll-item" id="scroll-5">
                <Head-title class="animate__animated" title="特色优势" name="为企业在工业互联网领域提供工业互联网标识解析领域答疑解惑"></Head-title>
                <div class="w">
                    <ul>
                        <li v-for="(item,index) in featureList" :key="index">
                            <div class="des">
                                <span>{{ item.name }}</span>
                                <em v-dompurify-html="item.des"></em>
                            </div>
                            <img :src="setImg(`ys-bg-${index+1}`)" alt="">
                        </li>
                    </ul>
                </div>
            </div>
            <div class="consult scroll-item" id="scroll-6">
                <Head-title class="animate__animated" title="咨询服务" name="为企业在工业互联网领域提供工业互联网标识解析领域答疑解惑"></Head-title>
                <div class="w">
                    <ul>
                        <li v-for="(item,index) in consultList" :key="index">
                            {{ item }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script> 
    import { mapState } from 'vuex';
    import HeadTitle from "@/components/HeadTitle";
    export default {
        name: 'Dashboard',
        components: { 
            HeadTitle
        },  
        data(){
            return {
                scrollNum: 0,
                fiexdNav: '',
                activeStep: 0,
                fiexdTop: 0,
                tab: 0, 
                originList:[{
                    title: '标识服务',
                    des:'本地管理标识<br>多种方案接入解析体系'
                },{
                    title: '应用服务',
                    des:'创新性的标识解析应用'
                },{
                    title: '数据集成',
                    des:'跨系统、跨设备数据采集'
                }],
                navList: ['企业节点','产品功能','应用场景','数据连接器','特色优势','咨询服务'],
                tabList:[
                    ['标识注册','标识解析','标识模版','标识统计','Origin自建模式','兼容托管模式','兼容IDIS','元数据模式','合规上报','协议丰富','区块标识BID','安全审计'],
                    ['企业节点管理平台','主动标识载体平台','企业节点管控系统','碳值计算应用','碳效码','网站数据增强系统','生产追溯','生命周期管理','产品售后','产品预测性维护','市场营销','一物一码','物流管理','订单管理','产品追溯'],
                    ['RPA自动化机器人','OCR、NLP识别','生产线通信协议','API、数据库接入','IOT设备通信','PLM数据源','MES数据源','WMS数据源','ERP数据源','SAP数据源','CRM数据源','通信模组','UICC','边缘网关','智能设备']
                ],
                functList: [{
                    name: '标识采集与互通',
                    des:'从设备到工业软件，全渠道异构数据采集,通过数据存储集群作为数据中台为企业提供关键决策'
                },{
                    name: '快速多方案对接',
                    des:'工业互联网<br>星火·链网<br>工业互联网平台'
                },{
                    name: '开放的应用市场',
                    des:'不仅可以使用标配的Origin系列标识应用，还可以通过开放能力接入二级节点特色应用和企业内部自建应用'
                }],
                applyList: [{
                    name: '适配多种解析体系',
                    des:'适用性广，可扩展性强'
                },{
                    name: '国密安全认证',
                    des:'通信报文支持SM2/SM3/SM4等国密算法'
                },{
                    name: '内生安全',
                    des:'标识数据企业自主可控，机密数据不外泄、保密数据需授权、普通数据接入网'
                },{
                    name: '弹性可伸缩',
                    des:'支持DAS硬盘扩容、ORIGIN集群水平弹性扩容'
                }],
                dataList:['工业软件类型数据连接器','生产线类型数据连接器','RPA机器人数据连接器','仿真类型连接器','OCR、NLP类型连接器'],
                featureList:[{
                    name: '方案广',
                    des:'多种数采工具<br>丰富的实施案例'
                },{
                    name: '见效快',
                    des:'快速部署<br>应用丰富'
                },{
                    name: '跨行业',
                    des:'已覆盖10+以上工业行业<br>形成产业上下游协同'
                },{
                    name: '可定制',
                    des:'数采、解析相关8个平台<br>产品，全部可定制'
                }],
                consultList:['标识解析解决方案','跨系统数据采集','企业节点建设','碳计算与标识解析','主动标识载体方案','二级节点建设']
            }
        },
        computed: {
            ...mapState({ 
                navHeight: state => state.app.navHeight
            }),
            applyClass() {
                let className = '';
                switch(this.tab) {
                case 0 :
                    className = 'fw-tab';
                    break;
                case 1 :
                    className = 'apply-tab';
                    break;
                case 2 :
                    className = 'data-tab';
                    break;
                }
                return className;
            }
        },
        mounted () {
            this.scrollNum =this.$refs.banner.offsetHeight; 
            window.addEventListener('scroll', this.handleScroll)
        },
        beforeDestroy() {
            // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: { 
            setImg(path) {
                return require(`@/assets/images/${path}.png`)
            },
            changeTab(index) {
                this.tab = index;
            },
            handleScroll () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                this.fiexdNav = scrollTop >= this.scrollNum ? 'fiexd-nav' : '';
                this.fiexdTop = scrollTop >= this.scrollNum ? (this.navHeight - 1) : 0;
                this.onScroll();
            },
            onScroll() {
                // 获取所有锚点元素
                const navContents = document.querySelectorAll('.scroll-item')
                // 所有锚点元素的 offsetTop
                const offsetTopArr = [];
                let num = this.$refs.projectNav.offsetHeight;
                navContents.forEach((item,index) => {
                    let topNum = 0;
                    if(index == 0){
                        topNum = item.offsetTop;
                    }else{
                        topNum = item.offsetTop - this.navHeight - num - 100;
                    }
                    offsetTopArr.push(topNum)
                })    
                // 获取当前文档流的 scrollTop
                let scrollTopNum = document.documentElement.scrollTop || document.body.scrollTop;
                // 定义当前点亮的导航下标  
                let navIndex = 0
                for (let n = 0; n < offsetTopArr.length; n++) {
                    // 如果 scrollTopNum 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
                    // 那么此时导航索引就应该是 n 了 
                    if (scrollTopNum >= offsetTopArr[n]) {
                        navIndex = n+1
                    }
                }
                // 把下标赋值给 vue 的 data
                this.activeStep = navIndex
            },
            toLetters(letter) {            
                this.activeStep = letter            
                let e = document.getElementById(`scroll-${letter+1}`)            
                if (e) {                
                    e.scrollIntoView({behavior: 'smooth',block:'center'}) //滚动到指定位置            
                }        
            } 
        },
    }
</script>

<style lang="scss" scoped> 
$basePath: '~@/assets/images/';
@mixin setBgImg($imgName) {
    background: url($basePath +$imgName) no-repeat center;
}
.project{
    %des{
        span,em{
            display: block;

        }
        span{
            font-size: 32px;
            height: 32px;
            font-weight: bold;
            line-height: 32px;
            margin-bottom: 23px;
        }
        em{
            font-size:19px;
            line-height: 26px;
        }
    }
    .banner{
        height: 600px;
    }
    &-nav{
        background: #fff;
        box-shadow: 0 20px 20px -20px #626c79;
        ul{
            display: flex;
            justify-content:space-between;
            align-items:center;
            li{
                display: flex; 
                align-items:center;
                height: 76px;
                padding:0 56px;
                font-size:20px;
                color:#666; 
                cursor: pointer;
                &.active,
                &:hover{
                    color:#0F52AE;
                    background: #F0F3F6;
                }
            }
        }
    }
    .origin-tab{
        @include setBgImg("fw-bg.png");
        background-size:100% 1013px;
        background-position: left bottom;
        .tab_tit{
            display: flex;
            li{ 
                @mixin setIcon($bgName) {
                    @for $i from 1 through 3{
                        &:nth-child(#{$i}){
                            .icon{
                                @include setBgImg("icon/project/tab-#{$bgName}-#{$i}.png");
                                background-size:54px 54px;
                            }
                        }
                    }
                    &:nth-child(1){
                        .icon{ 
                            background-size:46px 58px;
                        }
                    }
                    &:nth-child(3){
                        .icon{ 
                            background-size:46px 55px;
                        }
                    }
                }
                display: flex;
                justify-content:space-between; 
                width: 466px;
                height: 143px;
                padding: 30px 80px;
                background: #fff;
                cursor: pointer;
                .icon{
                    margin-top: 20px;
                    width: 54px;
                    height: 58px;
                }
                @include setIcon('nav');
                dl{
                    color:#666;
                    dt{
                        font-size:32px;
                        height: 32px;
                        font-weight: bold;
                        line-height: 32px;
                        margin-bottom: 25px;
                    }
                    dd{
                        font-size:20px; 
                        line-height: 22px;
                    }
                }
                &.active{
                    @include setBgImg('tab-active.png');
                    @include setIcon('active');
                    dl{
                        color:#fff;
                    }
                }
                
            }
        }
        .tab-cont{
            padding-bottom: 32px;
            ul{
                width: 100%;
                display: flex;
                justify-content:space-between;
                flex-wrap:wrap;
                li{
                    width: 230px;
                    text-align: center;
                    margin:45px 30px;
                    padding-top:136px;
                    font-size:28px;
                    line-height: 28px;
                    height: 28px;
                    color:#666; 
                }  
            }
        }
        &.fw-tab{
            .origin-list{
                li{
                    @for $i from 1 through 12{
                        &:nth-child(#{$i}){
                            @include setBgImg("icon/project/fw-#{$i}.png");
                            background-size:63px 77px;
                            background-position: center 13px;
                        }
                    } 
                    &:nth-child(4){
                        background-size:65px 66px; 
                    }
                }
            }
            
        }
        &.apply-tab{
            @include setBgImg("project-bg-3.png");
            .origin-list{
                li{
                    width: 256px; 
                    margin:45px 0;
                    @for $i from 1 through 15{
                        &:nth-child(#{$i}){
                            @include setBgImg("icon/project/apply-icon-#{$i}.png");
                            background-size:63px 78px;
                            background-position: center 13px;
                        }
                    } 
                    &:nth-child(3){
                        background-size:67px 78px; 
                    }
                    &:nth-child(4){
                        background-size:69px 69px; 
                    }
                    &:nth-child(5){
                        background-size:84px 78px; 
                    }
                    &:nth-child(7){
                        background-size:68px 64px; 
                    }
                    &:nth-child(10){
                        background-size:67px 78px; 
                    }
                    &:nth-child(12){
                        background-size:61px 61px; 
                    }
                }
            }
        }
        &.data-tab{
            @include setBgImg("data-bg.png");
            .origin-list{
                li{
                    width: 256px; 
                    margin:45px 0;
                    @for $i from 1 through 15{
                        &:nth-child(#{$i}){
                            @include setBgImg("icon/project/data-icon-#{$i}.png");
                            background-size:63px 78px;
                            background-position: center 13px;
                        }
                    } 
                    &:nth-child(2){
                        background-size:63px 80px; 
                    }
                    &:nth-child(14){
                        background-size:79px 71px; 
                    }
                    &:nth-child(15){
                        background-size:74px 74px; 
                    }
                    &:nth-child(6),
                    &:nth-child(7),
                    &:nth-child(8),
                    &:nth-child(9),
                    &:nth-child(10),
                    &:nth-child(11){
                        background-size:63px 67px; 
                    }
                }
            }
        } 
    }
    .function{
        &-cont{
            display: flex;
            justify-content:space-between;
            li{
                width:284px;
                text-align: center;
                padding:124px 0 111px;
                color:#666;
                @for $i from 1 through 3{
                    &:nth-child(#{$i}){
                        @include setBgImg("icon/project/icon-#{$i}.png");
                        background-size:63px 79px;
                        background-position: top center;
                    }
                }
                @extend %des;
            }
        }
    }
    .apply{
        background: #fff;
        padding-bottom: 70px;
        .w{
            display: flex;
            justify-content:space-between;
        }
        img{
            width:856px;
            height: 653px;
        }
        &-list{
            li{
                padding-bottom: 20px;
                b,em{
                    display: block;
                    padding-left: 60px;
                }
                b{
                    position: relative;
                    font-size:32px;
                    color:#0F52AE;
                    height: 32px;
                    line-height: 32px;
                    margin:52px 0 15px;
                    &::before{
                        content: '';
                        display: block;
                        width: 11px;
                        height: 11px;
                        border-radius: 50%;
                        background: #0F52AE;
                        position: absolute;
                        top: 10px;
                        left: 0;
                    }
                }
                em{
                    font-size: 20px;
                    color:#666;
                    height: 20px;
                    line-height: 26px; 
                }
            }
        }
    }
    .data-link{
        @include setBgImg('project-bg-1.png');
        padding-bottom: 56px;
        ul{
            display: flex;
            justify-content:center;
            flex-wrap:wrap;
            li{
                padding-top:137px;
                font-size: 32px;
                margin: 0 30px 116px;
                height: 32px;
                line-height: 32px;
                color:#666;
                @for $i from 1 through 5{
                    &:nth-child(#{$i}){
                        @include setBgImg("icon/project/data-#{$i}.png");
                        background-size:63px 73px;
                        background-position: top 17px center;
                    }
                }
                &:nth-child(1){
                    background-size:68px 72px;
                }
                &:nth-child(2){
                    background-size:63px 71px;
                }
                &:nth-child(3){
                    background-size:82px 75px;
                }
                &:nth-child(4){
                    background-size:69px 73px;
                }
            }
        }
    }
    .feature{
        background: #fff;
        padding-bottom: 117px;
        ul{
            display: flex;
            justify-content:space-between;
            li{
                background: #f1f5f8;
                .des{
                    padding: 160px 0 45px;
                    text-align: center;
                    color:#666;
                    @extend %des;
                }
                @for $i from 1 through 4{
                    &:nth-child(#{$i}){
                        .des{
                            @include setBgImg("icon/project/ys-#{$i}.png");
                            background-size:63px 78px;
                            background-position: top 37px center;
                        }
                    }
                }
                &:nth-child(1){
                    .des{
                        background-size: 75px 75px;
                    }
                }
                &:nth-child(2){
                    .des{
                        background-size: 71px 75px;
                    }
                }
                &:nth-child(3){
                    .des{
                        background-size: 64px 75px;
                    }
                }
                img{
                    height: 376px;
                }
            }
        }
    }
    .consult{
        @include setBgImg('project-zx.jpg');
        ul{
            display: flex;
            justify-content:space-between; 
            flex-wrap:wrap;
            li{
                width: 405px;
                height: 237px; 
                text-align: center;
                margin-bottom: 114px;
                padding-top: 168px;
                font-size: 32px;
                color:#666;
                line-height: 32px;
                box-shadow: 0 20px 20px -20px #626c79;
                transition: 1s;
                @for $i from 1 through 6{
                    &:nth-child(#{$i}){ 
                        background:#fff url('~@/assets/images/icon/project/zx-#{$i}.png') no-repeat center;
                        background-size:63px 77px;
                        background-position: top 41px center;
                    }
                }
                &:nth-child(4),
                &:nth-child(5),
                &:nth-child(6){
                    background-size:63px 75px;
                }
                &:hover{
                    transform: translateY(-8px);
                }
            }
        }
    }
    .fiexd-nav{
        position: fixed;
        top:83px;
        left: 0;
        width: 100%;
        z-index: 98;
    }
} 
@media only screen and (max-width: 750px) { 
    .project{
        .banner{
            height: auto;
        }
        .project-nav ul li{
            padding:0 14px;
            text-align: center;
            font-size: 16px;
        }
        .origin-tab{
            background-size: cover !important;
            background-position: center !important;
            .origin-tit{
                display: flex;
                overflow-x: auto;
                .w{
                    width:auto;
                }
                li{
                    width: 320px;
                    padding:10px 20px;
                    height: auto;
                    justify-content: normal;
                    span{
                        margin-right: 10px;
                    }
                    .icon{
                        margin-top:10px;
                    }
                    dl{
                        dt{
                            font-size: 20px;
                            margin-bottom: 15px;
                            height: 20px;
                            line-height: 20px;
                        } 
                        dd{
                            font-size: 14px;
                            height: auto;
                            line-height: 20px;
                        }
                    }
                }
            }
            .tab-cont{
                padding-bottom: 50px;
                ul.origin-list{
                    li{
                        padding-top:100px;
                        width:120px;
                        margin:30px 10px 0;
                        font-size: 14px;
                        line-height: 24px;
                        height: 24px;
                        background-size: 50% !important;
                    }
                }
            }
        }
        .function-cont{
             li{
                 padding:100px 0 30px;
                span{
                  font-size:18px;
                  height: 18px;
                  line-height: 18px;
                  margin-bottom: 10px;  
                }
                em{
                    font-size: 14px;
                }
             }
        }
        .apply{
            padding-bottom: 20px;
            .w{
                display: block;
            }
            img{
                display: none;
            }
            &-list{
                li{
                    margin-bottom: 20px;
                    padding-bottom: 0;
                    b{
                        font-size:16px;
                        height: 16px;
                        line-height: 16px;
                        margin-top: 0;
                        padding-left: 20px;
                        &::before{
                            width:10px;
                            height: 10px;
                            top:3px;
                        }
                    }
                    em{
                        font-size: 14px;
                        height: auto;
                        line-height: 18px;
                        padding-left: 20px;
                    }
                }
            }
        }
        .data-link{
            padding-bottom: 20px;
            ul{
                li{
                    font-size: 14px;
                    margin:20px;
                    padding-top: 100px;
                }
            }
        }
        .feature{
            padding-bottom: 20px;
            ul{
                flex-wrap:wrap;
                li{
                    width: 50%;
                    .des{
                        padding:130px 0 20px;
                        span{
                            font-size: 20px;
                            height: 20px;
                            line-height: 20px;
                            margin-bottom: 10px;
                        }
                        em{
                            font-size: 14px;
                        }
                    }
                }
            }
        }
        .consult{
            ul{
               li{
                   margin-bottom: 20px;
                   width: 48%;
                   font-size:14px;
                   padding:130px 0 10px;
                   height: auto;
               } 
            }
        }
    } 
    
}
</style>
<style lang="scss">
.main{
    background: #f0f3f6;
}
.origin{
    .title{
        padding:115px 0;
    }
}
.function{
    .title{
        padding:115px 0 117px;
    }
}
.apply{
    .title{
        padding:115px 0 68px;
    }
}
.data-link{
    .title{
       padding:115px 0 107px; 
    }  
}
.feature{
    .title{
        padding:115px 0 77px;
    }
}
.consult{
    .title{
        padding: 115px 0;
    }
}
@media only screen and (max-width: 750px) { 
    .origin,.function,.apply,.data-link,.feature,.consult{
        .title{
            padding:20px 0 30px;
            height: auto;
            span{
                height: auto;
            }
            em{
                padding: 0 20px;
            }
        }
    }
    .origin-tab{
        .w{
            width:100%;
            padding:0;
        }    
    } 
}
</style>